import { LitElement, html, css } from 'lit';

class InsertPointTooltip extends LitElement {
    static styles = css`
    .tooltiptext {
      font-size: 12px;
      background-color: black;
      color: #fff;
      text-align: left;
      border-radius: 6px;
      padding: 5px;
      position: absolute;
      bottom: 5px;
      left: 15%;
      transform: translateX(-25%);
      white-space: pre-wrap;
      min-width: 100px;
      opacity: 0.8;
    }

    .tooltiptext::after {
        content: " ";
        position: absolute;
        top: 100%;  /* tooltiptext の下端から */
        left: 50%;  /* 中央に配置 */
        margin-left: -5px;  /* 三角形の幅の半分だけ左にずらして中央に見えるようにする */
        border-width: 5px;
        border-style: solid;
        border-color: black transparent transparent transparent;  /* 上側の境界線が黒、他は透明 */
        opacity: 0.8; 
    }
  `;

    static properties = {
        targetElement: { type: Object }
    };

    constructor() {
        super();
        this.targetElement = null;
    }

    updated(changedProperties) {
    }

    adjustTooltipPosition() {
        if (!this.targetElement) return;

        requestAnimationFrame(() => {
            const tooltip = this.shadowRoot.querySelector('.tooltiptext');
            const tooltipRect = tooltip.getBoundingClientRect();
            const parentRect = this.targetElement.getBoundingClientRect();
            const viewportWidth = window.innerWidth;

            // 右側にはみ出している場合
            if (tooltipRect.right > viewportWidth) {
                tooltip.style.left = 'auto';
                tooltip.style.right = `${viewportWidth - parentRect.right}px`;
                tooltip.style.transform = 'translateX(0)';
            }

            // 左側にはみ出している場合
            if (tooltipRect.left < 0) {
                tooltip.style.left = `${parentRect.left}px`;
                tooltip.style.transform = 'translateX(0)';
            }

            // 上側にはみ出している場合
            if (tooltipRect.top < 0) {
                tooltip.style.bottom = 'auto';
                tooltip.style.top = `${parentRect.bottom}px`;
            }
        });
    }

    render() {
        this.adjustTooltipPosition();

        let text = "";
        if (this.targetElement) {
            const domId = this.targetElement.attributes['data-node-dom-id'].nodeValue;
            let explain = this.targetElement.attributes['data-node-explain'].nodeValue;
            if (explain) {
                explain = ` (${explain})`;
            } else {
                explain = "";
            }
            text = "id: " + domId + explain;
        }


        return html`
        <span class="tooltiptext">${text}</span>
        `;
    }
}

customElements.define('insert-point-tooltip', InsertPointTooltip);